module.exports = __webpack_public_path__ + "img/solar_trash-bin-minimalistic-linear.4d82bc83.svg";